import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../api';

const DEFAULT = { freshdesk: false, atlassian: false, jira: false, figma: false };

const IntegrationContext = createContext({
  status: DEFAULT,
  loading: true,
  refresh: () => {},
});

export function IntegrationProvider({ children }) {
  const [status,  setStatus]  = useState(DEFAULT);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    // Cache-buster: integration status changes on connect/disconnect, so an
    // explicit refresh must bypass any HTTP cache (older browsers may still
    // hold a cached response from before the server switched to no-store).
    api.get('/integrations/status', { params: { _t: Date.now() } })
      .then(r => setStatus({
        freshdesk: !!r.data.freshdesk,
        atlassian: !!r.data.atlassian,
        jira:      !!r.data.jira,
        figma:     !!r.data.figma,
      }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <IntegrationContext.Provider value={{ status, loading, refresh }}>
      {children}
    </IntegrationContext.Provider>
  );
}

export const useIntegrations = () => useContext(IntegrationContext);
